import {
  getCarrierNamesOtcTemplate,
  getCarrierNamesPartBTemplate,
  getVueCarrierNames,
} from "../../shortcodes/templates";

let carrierNames = null;
const visualizeCarrierNames = content => {
  carrierNames = content.querySelectorAll('[data-wrapper-id="carrier-names"]');
  if (carrierNames.length > 0) {
    carrierNames.forEach(item => {
      const type = item.querySelector("carrier-names")?.getAttribute("type");
      if (type === "otc") {
        item.innerHTML = getCarrierNamesOtcTemplate();
      } else if (type === "partb") {
        item.innerHTML = getCarrierNamesPartBTemplate();
      }
    });
  }
};

const serializeCarrierNames = content => {
  const carrierNames = content.querySelectorAll('[data-wrapper-id="carrier-names"]');
  if (carrierNames.length > 0) {
    carrierNames.forEach(item => {
      if (!item.querySelector("carrier-names")) {
        const type = item.querySelector(".carrier-names")?.getAttribute("type");
        if (type) {
          item.innerHTML = getVueCarrierNames(type);
        }
      }
    });
  }
};

export { visualizeCarrierNames, serializeCarrierNames };
